import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postSubscribeOnChannel } from '../../api/channels';

import { generateChannelCIDKey } from '../../utils/generateChannelCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../utils/asyncThunkRequest';

import { REQUEST } from '../../constants/request';

export const subscribeToContent = createAsyncThunk(
  'checkout/subscribeToContent',
  async ({ path, body }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const maybeSubscribed = await postSubscribeOnChannel(
        { path, body },
        {
          cancelToken: source.token,
        },
      );

      return maybeSubscribed.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const state = getState();

      return !(
        state.checkout.request[generateChannelCIDKey(path)]?.loading ===
        REQUEST.pending
      );
    },
  },
);

export const CheckoutSlice = createSlice({
  name: 'checkout',
  initialState: {
    request: {},
  },
  extraReducers: {
    [subscribeToContent.pending]: (state, action) => {
      checkAndSetLoadingWithId(
        state.request,
        action,
        generateChannelCIDKey(action.meta.arg.path),
      );
    },
    [subscribeToContent.fulfilled]: (state, action) => {
      const channelCIDKey = generateChannelCIDKey(action.meta.arg.path);

      onMatchedRequest(state.request[channelCIDKey], action);
    },
    [subscribeToContent.rejected]: (state, action) => {
      handleRequestRejection(
        state.request[generateChannelCIDKey(action.meta.arg.path)],
        action,
      );
    },
  },
});

export default CheckoutSlice.reducer;
